export const en_GB = {
    LEFT: 'Left: Move to the previous day.',
    RIGHT: 'Right: Move to the next day.',
    DOWN: 'Down: Move to the next row.',
    UP: 'Up: Move to the previous row.',
    PGUP: 'PgUp: Move to the previous month.',
    PGDOWN: 'PgDown: Move to the next month.',
    HOME: 'Home: Move to the previous year.',
    END: 'End: Move to the next year.',
    ESC: 'Esc/Today/Close: close the calendar.',
    TITLE: 'Keyboard Instructions'
};
